import { capfirst, intcomma } from 'journalize';
import cx from 'classnames';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';
const BROADCAST_HEADER_IMG = `${process.env.PUBLIC_PATH}assets/images/election-runoff-horizontal-logo.png`;

// components
import CountyTable from './CountyTable';

// internal
import {
  sort_candidates_by_party,
  get_directory_slug,
} from '../election-utils';
import sumValues from '../utils/sum-values';

// text
import text from '../../../data/text.json';

const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any },
  flags: { [key: string]: any },
  columnCount: number,
  contestTitle: string,
  includeCountyRundown?: boolean,
  isShowcaseRace?: boolean,
  renderParty: any,
  renderCandidate: any,
  visibleCandidatesCount?: number,
  embedType: string,
  broadcastHeaderImage: string,
  activeContestId: string
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      flags,
      columnCount,
      contestTitle,
      isShowcaseRace,
      includeCountyRundown,
      renderParty,
      renderCandidate,
      tableHeader,
      embedType,
      broadcastHeaderImage,
      activeContestId
    } = this.props;

    let totalVotes;
    let candidates;

    const isStatewide = contest.division_type === 'statewide';

    const IsFlagged = flags && flags.length > 0 ? true : false;

    // The Republic API slugs don't match the directory url slugs so we need to get them

    let directory_slug;

    if (contest[0]) {
      directory_slug = get_directory_slug(contest[0].office);

    }

    const rowClass = cx({
      seat__races: !isShowcaseRace,
      seat__highlight_races: isShowcaseRace,
    });

    const titleClass = cx({
      seat__title: !IsFlagged,
      'seat__title flagged': IsFlagged,
    });

    
    let embedTypeUsable = 'none'
    
    if (typeof embedType !== 'undefined') {
      embedTypeUsable = embedType;
    }

    // set the class on the disclaimer, changes between partner embed and the default index page
    const isPartner = embedTypeUsable && embedTypeUsable == 'partner' ? true : false;

    const disclaimerClass = cx(
      'disclaimer-race',
      {
        'disclaimer-partner': isPartner
      } // disclaimer-partner needs to be after disclaimer-race
    );

    return (
      <div class="seat">
        {embedTypeUsable.includes('broadcast') && (
          <header class="embed-logo-container">
            <a href="https://www.texastribune.org/" target="_blank" rel="noopener noreferrer">
              <img class="embed-logo" src={broadcastHeaderImage} alt="Texas 2020 Primary Election Results presented by The Texas Tribune" />
            </a>
          </header>
        )}
        {IsFlagged == true && (
          <div class="seat__flag">
            <p class="office__flag">
              <span class="gold-star">★</span>Race to watch
            </p>
          </div>
        )}

        {!isShowcaseRace && !(embedTypeUsable == 'partner') && !(embedTypeUsable.includes('broadcast')) && (
          <h3 class={titleClass}>
            <span>{contestTitle}</span>
            {directory_slug[0] != null && (
              <a
                href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contest[0]['office_division']}`}
              >
                <span class="icon-div" title="Click to learn more about this district">
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
          </h3>
        )}

        {/* {contestTitle == 'Texas House District 142' && (
          <div class={disclaimerClass}>
            {embedTypeUsable == 'partner' && (
              <div class="disclaimer-header">Regarding results for {contestTitle}</div>
            )}
            {text.error.find(text => text.type == 'texas-house-district-142').value}
          </div>
        )}

        {contestTitle == 'U.S. House District 10' && (
          <div class={disclaimerClass}>
            {embedTypeUsable == 'partner' && (
              <div class="disclaimer-header">Regarding results for {contestTitle}</div>
            )}
            {text.error.find(text => text.type == 'us-house-district-10').value}
          </div>
        )} */}

        {IsFlagged == true && (
          <div class="seat__flag">
            <p class="seat__flag__text">{converter.convert(flags[0].value)}</p>
          </div>
        )}

        <div class={rowClass}>
          {!(embedTypeUsable.includes('broadcast')) && !isShowcaseRace && contest.map((party: any, index) => renderParty(party, index))}

          {tableHeader}
          
          {isShowcaseRace && renderParty(contest)}
          {embedTypeUsable.includes('broadcast') && renderParty(contest.find(party => party.id == activeContestId))}
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default Contest;
